// extracted by mini-css-extract-plugin
export default {"body":"QRModal_body__e8GiL","qrContainer":"QRModal_qrContainer__er32g","url":"QRModal_url__80G4R","actions":"QRModal_actions__YkzfJ","actionBtn":"QRModal_actionBtn__bisqD"};